import { jsx as _jsx } from "react/jsx-runtime";
import { LayoutContainer } from '../layout-container/LayoutContainer';
const PrivateRoute = ({ component }) => {
    return _jsx(LayoutContainer, { children: component });
};
export default PrivateRoute;
//# sourceMappingURL=PrivateRoute.js.map